// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryCommsTable_root__3uyS-","thead":"CategoryCommsTable_thead__1YR9A"};